export default __webpack_public_path__ + "static/media/wegovy-choose-injection-site.f39c5858.mp4";